import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/Layout/MainLayout";
import { BackIcon } from "../../../components/Dashboard/DataCenterIcons";
import "../../../assets/styles/rdcstatus.css";
import { commonService } from "../../../services/commonService";
import Pagination from '../../../components/Common/Pagination';
import Loader from '../../../components/Common/Loader';
import { ROUTES } from "../../../utils/constants";

const FDCListPage: React.FC = () => {
    const navigate = useNavigate();
    const [downloads, setDownloads] = useState<any[]>([]);
    const [pageDetail, setPageDetail] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(5);

    // Popup states
    const [viewPopup, setViewPopup] = useState<{ open: boolean; item: any }>({
        open: false,
        item: null
    });

    const [confirmPopup, setConfirmPopup] = useState<{ open: boolean; item?: any; action?: string }>({
        open: false,
        item: null,
        action: ""
    });

    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [successMsg, setSuccessMsg] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            const payload = {
                page: 1,
                page_size: pageSize,
            };

            try {
                const response = await commonService.fdcList(payload);
                setDownloads(response?.data);
                console.log("FDC List Response:", response);
                const page_data = {
                    page: response.page,
                    total_pages: response.total_pages,
                    total_records: response.total,
                    page_size: response.page_size,
                };
                setPageDetail(page_data);
            } catch (err) {
                setErrorMsg("Failed to load records.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const fetchData = async (newPage: any) => {
        const payload = {
            page: newPage,
            page_size: pageSize,
        };

        try {
            setLoading(true);
            const response = await commonService.fdcList(payload);
            setDownloads(response?.data);

            const page_data = {
                page: response.page,
                total_pages: response.total_pages,
                total_records: response.total,
                page_size: response.page_size,
            };
            setPageDetail(page_data);
            return response?.data;
        } catch (err) {
            setErrorMsg("Failed to load records.");
        } finally {
            setLoading(false);
        }
    };

    const onChangeAction = async (item: any, value: string) => {
        if (value === "details") {
            setViewPopup({ open: true, item });
        } else if (value === "file_details") {
            // Handle file details action (you can implement this separately)
            setViewPopup({ open: true, item });
        } else if (value === "edit") {
            navigate(ROUTES.FDC_EDIT, { state: { editData: item } });
        } else if (value === "disable" || value === "enable") {
            setConfirmPopup({ open: true, item, action: value });
            return;
        }
    };

    const handleStatusChange = async () => {
        const { item, action } = confirmPopup;
        try {
            setLoading(true);
            setConfirmPopup({ open: false, item: null, action: "" });
            const response = await commonService.fdcDelete(item.id);
            setSuccessMsg(response?.data?.status == 'active' ? "Project enabled successfully" : "Project disabled successfully");
            setTimeout(() => setSuccessMsg(null), 5000); // hide after 5 sec
            fetchData(pageDetail.page);
        } catch (err) {
            setLoading(false);
            alert("Action failed");
        } finally {
            // setLoading(false);
        }
    };

    const handleEditClick = () => {
        if (viewPopup.item && viewPopup.item.customer_email === null) {
            navigate(ROUTES.FDC_EDIT, { state: { editData: viewPopup.item } });
        }
    };

    // Helper function to format criteria display
    const formatCriteria = (criteria: string) => {
        if (!criteria) return "N/A";
        return criteria.split(",").map(c => c.trim()).join(", ");
    };

    // Helper function to format date
    const formatDate = (dateString: string) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleString("en-IN", {
            timeZone: "America/Los_Angeles",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    };

    const onChangeViewAction = async (item: any, file_name: any, id: any, value: string) => {

        if (value === "Download") {
            try {
                const response = await commonService.fdcDownloadFile(id);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.download = file_name;
                link.click();
                // Cleanup
                window.URL.revokeObjectURL(url);
            } catch (err) {
            } finally { }
        } else if (value === "append" || value === "reupload") {
            navigate(ROUTES.FDC_REUPLOAD_APPEND, { state: { FileId: id, actionType: value, stage: item?.stage } });
        } else if (value === "disable" || value === "enable") {
            const response = await commonService.fdcFileStatusChange(id);
            setSuccessMsg(response?.data?.status == 'active' ? "File enabled successfully" : "File disabled successfully");
            setTimeout(() => setSuccessMsg(null), 5000);
            setViewPopup({ open: false, item: null });
            const updatedList = await fetchData(pageDetail.page);
            const updatedRow = updatedList.find((row: any) => row.id === item.id);
            if (updatedRow) {
                setViewPopup({ open: true, item: updatedRow });
            }
        }
    }

    return (
        <MainLayout>
            <div className="rde-downloads-page" style={{ backgroundColor: "#f0f8ff" }}>

                {/* Header */}
                <div className="rde-header">
                    <div className="rde-back-button-container">
                        <button onClick={() => navigate(ROUTES.VDC_FDC)} className="rde-back-button">
                            <BackIcon />
                            Back
                        </button>
                    </div>
                    <h1 className="rde-title">FDC Project Detail</h1>
                </div>

                {/* Main Table */}
                <div>
                    {loading ? (
                        <Loader text='Loading...' />
                    ) : (
                        <div className="mt-3 rt-tablewrap">
                            <table className="table table-bordered table-striped text-center">
                                <thead className="table-primary">
                                    <tr>
                                        <th>Sl No</th>
                                        <th>Project ID</th>
                                        <th>CRM ID</th>
                                        <th>Status</th>
                                        <th>Project Submission Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {downloads.length > 0 ? (
                                        downloads.map((item, index) => (
                                            <tr key={item.request_id || index}>
                                                <td data-label="Sl No"> {((pageDetail.page - 1) * pageDetail.page_size) + (index + 1)}</td>
                                                <td data-label="Project ID">{item.projectid}</td>
                                                <td data-label="CRM ID">{item.crm_id}</td>
                                                <td data-label="Status">
                                                    <span style={{
                                                        padding: "2px 8px",
                                                        borderRadius: "4px",
                                                        backgroundColor: item.status === "active" ? "#d4edda" : "#f8d7da",
                                                        color: item.status === "active" ? "#155724" : "#721c24"
                                                    }}>
                                                        {item.status || "N/A"}
                                                    </span>
                                                </td>
                                                <td data-label="Project Submission Date">
                                                    {formatDate(item.created_at)}
                                                </td>
                                                <td data-label="Action">
                                                    <select
                                                        className="vdc-action-select"
                                                        onChange={(e) => {
                                                            if (e.target.value !== "") {
                                                                onChangeAction(item, e.target.value);
                                                                e.target.value = "";
                                                            }
                                                        }}
                                                    >
                                                        <option value="">⚙️ Action</option>
                                                        <option value="details">📋 View Details</option>
                                                        {/* <option value="file_details">📄 File Details</option> */}
                                                        {item?.customer_email == null && (
                                                            <>
                                                                <option value="edit">✏️ Edit</option>
                                                                {item?.status === "active" ? (
                                                                    <option value="disable">🚫 Disable</option>
                                                                ) : (
                                                                    <option value="enable">🔓 Enable</option>
                                                                )}
                                                            </>
                                                        )}
                                                    </select>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={6}>No download records found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Pagination */}
                <Pagination
                    page={pageDetail.page}
                    total_pages={pageDetail.total_pages}
                    total_records={pageDetail.total_records}
                    page_size={pageDetail.page_size}
                    onPageChange={(newPage) => fetchData(newPage)}
                />

                {/* Project View Popup */}
                {viewPopup.open && viewPopup.item && (
                    <div className="popup-overlay">
                        <div className="popup" style={{
                            width: "min(1200px, 92vw)",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            padding: "25px"
                        }}>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px",
                                borderBottom: "2px solid #61A1D4",
                                paddingBottom: "10px"
                            }}>
                                <h3 style={{ margin: 0, color: "#2c3e50" }}>📋 Project Details</h3>
                                <button
                                    onClick={() => setViewPopup({ open: false, item: null })}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: "24px",
                                        cursor: "pointer",
                                        color: "#666"
                                    }}
                                >
                                    ×
                                </button>
                            </div>

                            <div className="fdc-detail-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                                {/* Left Column */}
                                <div>
                                    <div className="detail-row">
                                        <strong>Project ID:</strong>
                                        <span>{viewPopup.item.projectid}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>CRM ID:</strong>
                                        <span>{viewPopup.item.crm_id}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Deal ID:</strong>
                                        <span>{viewPopup.item.deal_id}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Project Tier:</strong>
                                        <span>{viewPopup.item.project_tire || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Summary:</strong>
                                        <span>{viewPopup.item.summary || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Brand Name:</strong>
                                        <span>{viewPopup.item.brand_name || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Record Type:</strong>
                                        <span>{viewPopup.item.record_type || "N/A"}</span>
                                    </div>
                                    {(viewPopup.item.record_type === "refulfillment" || viewPopup.item.record_type === "credit_fulfillment") && (
                                        <div className="detail-row">
                                            <strong>Refulfillment ID:</strong>
                                            <span>{viewPopup.item.refulfillment_id || "N/A"}</span>
                                        </div>
                                    )}
                                    {(viewPopup.item.record_type === "refulfillment" || viewPopup.item.record_type === "credit_fulfillment") && (
                                        <div className="detail-row">
                                            <strong>Comment:</strong>
                                            <span>{viewPopup.item.comment || "N/A"}</span>
                                        </div>
                                    )}
                                    <div className="detail-row">
                                        <strong>Fulfillment Type:</strong>
                                        <span>{viewPopup.item.fulfillment_type || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>List Type:</strong>
                                        <span>{formatCriteria(viewPopup.item.criteria)}</span>
                                    </div>
                                </div>

                                {/* Right Column */}
                                <div>
                                    <div className="detail-row">
                                        <strong>Number of Contacts:</strong>
                                        <span>{viewPopup.item.number_of_contacts || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Data Fields:</strong>
                                        <span>{viewPopup.item.data_fields || "N/A"}</span>
                                    </div>
                                    <div className="detail-row" >
                                        <strong>Other Criteria:</strong>
                                        {/* <span>{viewPopup.item.other || "N/A"}</span> */}
                                        <span style={{textAlign:"left"}}
                                            dangerouslySetInnerHTML={{
                                                __html: viewPopup.item.other || "N/A"
                                            }}
                                        />
                                    </div>
                                    <div className="detail-row">
                                        <strong>Survey Status:</strong>
                                        <span>{viewPopup.item.survey_status || "N/A"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Status:</strong>
                                        <span style={{
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: viewPopup.item.status === "active" ? "#d4edda" : "#f8d7da",
                                            color: viewPopup.item.status === "active" ? "#155724" : "#721c24"
                                        }}>
                                            {viewPopup.item?.status ? viewPopup.item.status[0].toUpperCase() + viewPopup.item.status.slice(1) : "N/A"}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Created At:</strong>
                                        <span>{formatDate(viewPopup.item.created_at)}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Updated At:</strong>
                                        <span>{formatDate(viewPopup.item.updated_at)}</span>
                                    </div>
                                    <div className="detail-row">
                                        <strong>Total Files:</strong>
                                        <span>{viewPopup.item.total_files || 0}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Enrichment Fields Section */}
                            {!viewPopup.item.fulfillment_type && (
                                <>
                                    <div style={{
                                        marginTop: "20px",
                                        paddingTop: "15px",
                                        borderTop: "1px dashed #ddd"
                                    }}>
                                        <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>Enrichment Details</h4>
                                        <div className="fdc-detail-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                                            <div className="detail-row">
                                                <strong>Geography:</strong>
                                                <span>{viewPopup.item.geography || "N/A"}</span>
                                            </div>
                                            <div className="detail-row">
                                                <strong>Industry:</strong>
                                                <span>{viewPopup.item.industry || "N/A"}</span>
                                            </div>
                                            <div className="detail-row">
                                                <strong>Technologies:</strong>
                                                <span>{viewPopup.item.technologies || "N/A"}</span>
                                            </div>
                                            <div className="detail-row">
                                                <strong>Job Title:</strong>
                                                <span>{viewPopup.item.job_title || "N/A"}</span>
                                            </div>
                                            <div className="detail-row">
                                                <strong>Company Size:</strong>
                                                <span>{viewPopup.item.company_size || "N/A"}</span>
                                            </div>
                                            <div className="detail-row">
                                                <strong>Revenue Size:</strong>
                                                <span>{viewPopup.item.revenue_size || "N/A"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Files Section */}
                            {viewPopup.item.file && viewPopup.item.file.length > 0 && (
                                <div style={{
                                    marginTop: "20px",
                                    paddingTop: "15px",
                                    borderTop: "1px dashed #ddd"
                                }}>
                                    <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>Uploaded Files</h4>
                                    <table className="fdc-files-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#f8f9fa" }}>
                                                <th style={{ padding: "8px", border: "1px solid #dee2e6" }}>File Name</th>
                                                <th style={{ padding: "8px", border: "1px solid #dee2e6" }}>Status</th>
                                                <th style={{ padding: "8px", border: "1px solid #dee2e6" }}>Uploaded At</th>
                                                <th style={{ padding: "8px", border: "1px solid #dee2e6" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {viewPopup.item.file.map((file: any, index: number) => (
                                                <tr key={index}>
                                                    <td data-label="File Name" style={{ padding: "8px", border: "1px solid #dee2e6" }}>
                                                        {file.file_name}
                                                    </td>
                                                    <td data-label="Status" style={{ padding: "8px", border: "1px solid #dee2e6" }}>
                                                        <span style={{
                                                            padding: "2px 8px",
                                                            borderRadius: "4px",
                                                            backgroundColor: file.status === "active" ? "#d4edda" : "#f8d7da",
                                                            color: file.status === "active" ? "#155724" : "#721c24"
                                                        }}>
                                                            {file.status || "N/A"}
                                                        </span>
                                                    </td>
                                                    <td data-label="Uploaded At" style={{ padding: "8px", border: "1px solid #dee2e6" }}>
                                                        {formatDate(file.created_at)}
                                                    </td>
                                                    <td data-label="Action" style={{ padding: "8px", border: "1px solid #dee2e6" }}>
                                                        <select
                                                            className="vdc-action-select"
                                                            onChange={(e) => {
                                                                if (e.target.value !== "") {
                                                                    onChangeViewAction(viewPopup.item, file?.file_name, file?.id, e.target.value);
                                                                    e.target.value = "";
                                                                }
                                                            }}
                                                        >
                                                            <option value="">⚙️ Action</option>
                                                            <option value="Download">⬇️ Download File</option>
                                                            {viewPopup.item.customer_email == null && (() => {
                                                                // Mirrors the backend's _raise_if_project_locked: these
                                                                // three stages block file changes outright, with one
                                                                // carved-out exception - replacing (never appending)
                                                                // within 5 days of delivery (reupload_deadline, from
                                                                // the list API).
                                                                const LOCKED_STAGES = ["ready_to_deliver", "delivered", "rejected"];
                                                                const isLocked = LOCKED_STAGES.includes(viewPopup.item.stage);
                                                                const withinReuploadWindow = viewPopup.item.stage === "delivered"
                                                                    && viewPopup.item.reupload_deadline
                                                                    && new Date(viewPopup.item.reupload_deadline) > new Date();
                                                                const canAppend = !isLocked;
                                                                const canReupload = !isLocked || withinReuploadWindow;
                                                                return (
                                                                    <>
                                                                        {canAppend && <option value="append">➕ Append</option>}
                                                                        {canReupload && <option value="reupload">🔄 Re-Upload</option>}
                                                                        {file?.status === "active" ? (
                                                                            <option value="disable">🚫 Disable</option>
                                                                        ) : (
                                                                            <option value="enable">🔓 Enable</option>
                                                                        )}
                                                                    </>
                                                                );
                                                            })()}
                                                        </select>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div style={{
                                marginTop: "25px",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "10px",
                                paddingTop: "15px",
                                borderTop: "1px solid #eee"
                            }}>
                                <button
                                    onClick={() => setViewPopup({ open: false, item: null })}
                                    style={{
                                        background: "#6c757d",
                                        color: "white",
                                        padding: "8px 20px",
                                        borderRadius: "5px",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: "14px"
                                    }}
                                >
                                    Close
                                </button>

                                {/* Show Edit button only if customer_email is null */}
                                {viewPopup.item.customer_email === null && (
                                    <button
                                        onClick={handleEditClick}
                                        style={{
                                            background: "#61A1D4",
                                            color: "white",
                                            padding: "8px 20px",
                                            borderRadius: "5px",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px"
                                        }}
                                    >
                                        ✏️ Edit Project
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Error Popup */}
                {errorMsg && (
                    <div className="popup-overlay">
                        <div className="popup" style={{ textAlign: "center" }}>
                            <p>{errorMsg}</p>
                            <button onClick={() => setErrorMsg(null)} style={{
                                backgroundColor: "#61A1D4",
                                padding: "3px 10px",
                                borderRadius: "7px",
                                textAlign: "center",
                                color: "white",
                                border: "none",
                                cursor: "pointer"
                            }}>Close</button>
                        </div>
                    </div>
                )}

                {/* Confirm Popup */}
                {confirmPopup.open && (
                    <div className="popup-overlay">
                        <div className="popup" style={{ textAlign: "center", padding: "20px" }}>
                            <p>Are you sure you want to {confirmPopup.action} this project?</p>

                            <div style={{ marginTop: "15px", display: "flex", gap: "10px", justifyContent: "center" }}>

                                <button
                                    onClick={handleStatusChange}
                                    style={{ background: "#61A1D4", color: "#fff", padding: "6px 14px", borderRadius: "5px", border: "none", cursor: "pointer" }}>
                                    Yes, Proceed
                                </button>

                                <button
                                    onClick={() => setConfirmPopup({ open: false })}
                                    style={{ background: "#ffb2afff", color: "#fff", padding: "6px 14px", borderRadius: "5px", border: "none", cursor: "pointer" }}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Success Toast Popup */}
                {successMsg && (
                    <div style={{
                        position: "fixed",
                        top: "20px",
                        right: "20px",
                        backgroundColor: "#28a745",
                        color: "white",
                        padding: "12px 20px",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                        fontSize: "15px",
                        zIndex: 9999,
                        transition: "0.3s ease-in-out"
                    }}>
                        {successMsg}
                    </div>
                )}
            </div>

            <style>{`
                .detail-row {
                    margin-bottom: 12px;
                    display: flex;
                    justify-content: space-between;
                    padding: 8px;
                    background-color: #f8f9fa;
                    border-radius: 5px;
                    border-left: 4px solid #61A1D4;
                }
                .detail-row strong {
                    color: #2c3e50;
                    min-width: 150px;
                }
                .detail-row span {
                    color: #495057;
                    text-align: right;
                    word-break: break-word;
                    max-width: 250px;
                }
                .popup-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }
                .popup {
                    background: white;
                    border-radius: 10px;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.2);
                    animation: fadeIn 0.3s ease-out;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @media (max-width: 768px) {
                    .fdc-detail-grid { grid-template-columns: 1fr !important; }
                    .detail-row { flex-direction: column; align-items: flex-start; gap: 4px; }
                    .detail-row span { text-align: left; max-width: 100%; }
                    .fdc-files-table, .fdc-files-table thead, .fdc-files-table tbody, .fdc-files-table tr, .fdc-files-table td { display: block; width: 100%; }
                    .fdc-files-table thead { display: none; }
                    .fdc-files-table tr { border: 1px solid #dee2e6; border-radius: 8px; margin-bottom: 10px; overflow: hidden; }
                    .fdc-files-table td { border: none !important; border-bottom: 1px solid #f1f3f5 !important; text-align: left !important; }
                    .fdc-files-table tr td:last-child { border-bottom: none !important; }
                    .fdc-files-table td[data-label]::before {
                        content: attr(data-label); display: block; font-weight: 700; font-size: 10.5px; text-transform: uppercase;
                        letter-spacing: 0.03em; color: #6b7280; margin-bottom: 3px;
                    }
                }
            `}</style>
        </MainLayout>
    );
};

export default FDCListPage;